import { Star, Quote } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const TESTIMONIALS = [
  {
    quote:
      "After the hailstorm, three companies told me I needed a whole new roof. Seraph inspected it, showed me photos, and told me honestly that a repair would buy me years. They earned a customer for life.",
    name: "Mark & Dana Whitfield",
    location: "Carmel, IN",
    service: "Hail Damage Inspection",
  },
  {
    quote:
      "They treated our home like it was their own. Every promise they made, they kept — on schedule, on budget, and the crew left the yard cleaner than they found it.",
    name: "Sarah Jensen",
    location: "Fishers, IN",
    service: "Roof Replacement",
  },
  {
    quote:
      "As a widow handling storm damage alone, I was nervous about being taken advantage of. They walked me through the insurance process patiently and never pressured me once. Godly people, excellent work.",
    name: "Ruth Callahan",
    location: "Greenwood, IN",
    service: "Insurance Restoration",
  },
];

const Stars = () => (
  <div className="flex gap-1">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="h-3.5 w-3.5 fill-gold text-gold" />
    ))}
  </div>
);

export default function Testimonials() {
  return (
    <section
      id="reviews"
      data-testid="testimonials-section"
      className="relative border-t border-white/10 py-28 md:py-40"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <div className="mb-16 flex flex-col justify-between gap-8 md:mb-24 lg:flex-row lg:items-end">
          <Reveal>
            <Eyebrow>Homeowner Stories</Eyebrow>
            <h2 className="mt-6 font-serif text-5xl font-medium leading-[1.02] tracking-tight md:text-6xl">
              Trusted by Neighbors.
              <br />
              <span className="italic text-gold">Proven by Integrity.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="max-w-sm text-sm leading-relaxed text-white/55">
              We measure success one home — and one honest conversation — at a time.
              Here's what families across Central Indiana say about working with us.
            </p>
          </Reveal>
        </div>

        <div className="grid gap-px border border-white/10 bg-white/10 lg:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal
              key={t.name}
              delay={i * 0.1}
              className={`group relative bg-ink ${i === 1 ? "lg:-translate-y-8" : ""}`}
            >
              <figure
                data-testid={`testimonial-card-${i + 1}`}
                className={`flex h-full flex-col justify-between p-8 transition-colors duration-500 group-hover:bg-onyx md:p-10 ${
                  i === 1 ? "border border-gold/25 bg-onyx" : ""
                }`}
              >
                <div>
                  <div className="flex items-center justify-between">
                    <Stars />
                    <Quote className="h-6 w-6 text-gold/40 transition-colors duration-300 group-hover:text-gold" />
                  </div>
                  <blockquote className="mt-8 font-serif text-xl font-light italic leading-relaxed text-white/85 md:text-2xl">
                    &ldquo;{t.quote}&rdquo;
                  </blockquote>
                </div>
                <figcaption className="mt-10 border-t border-white/10 pt-6">
                  <p className="text-sm font-semibold text-white">{t.name}</p>
                  <p className="mt-1 text-xs text-white/45">{t.location}</p>
                  <span className="mt-4 inline-block border border-gold/30 bg-gold/5 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-gold">
                    {t.service}
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
